import { ProductState, DefaultProductState } from "../state";
import { ProductActionTypes} from './productTypes';
import { Reducer } from "redux";
import { UpdateProductAction } from "./productActions";

type Action = UpdateProductAction;

const updateState : Reducer<ProductState, Action> = (state: ProductState = DefaultProductState, action) => {
    switch(action.type) {
        case ProductActionTypes.UPDATE_PRODUCT:
            return {...state, currentProduct: { ...state.currentProduct, type: action.payload, c_VALUES: state.currentProduct.c_VALUES, sizes: state.currentProduct.sizes } }
        case ProductActionTypes.UPDATE_INPUT_DATA:
            //hier wird geprüft ob im selben fenster bereits eine Berechnung stattgefunden hat. Wenn ja ist das obj. calculationOutputData gefüllt 
            //und ich setze es wieder zurück um das Ergebnis fenster (Result.tsx) auszublenden.
            if(state.currentProduct.calculationOutputData !== undefined) {
                return {...state, currentProduct: { ...state.currentProduct, calculationOutputData: undefined}, productInputData: {...state.productInputData, ...action.payload} }
            } else {
                return {...state, productInputData: {...state.productInputData, ...action.payload} }
            }            
        case ProductActionTypes.UPDATE_INPUT_DATA_REQUIRED_FIELDS:
            return {...state, productInputData: {...state.productInputData, errorFields: {...action.payload }}}
        case ProductActionTypes.FETCH_PRODUCT_MATERIAL_REQUEST:
            return { ...state, currentProduct: {...state.currentProduct, materials: action.payload}}
        case ProductActionTypes.FETCH_PRODUCT_CVALUES_REQUEST:
            return { ...state, loading: true }
        case ProductActionTypes.FETCH_PRODUCT_CVALUES_SUCCESS:
            return { ...state, loading: false, currentProduct: { ...state.currentProduct, c_VALUES: action.payload } }
        case ProductActionTypes.FETCH_PRODUCT_METADATA_SUCCESS:
            return { ...state, loading: false, currentProduct: {...state.currentProduct, clampexType: action.payload }}
        case ProductActionTypes.FETCH_PRODUCT_CVALUES_ERROR:
            return { ...state, loading: false, errors: action.payload }
        case ProductActionTypes.FETCH_PRODUCT_SIZES_REQUEST:
            return { ...state, loading: true }
        case ProductActionTypes.FETCH_PRODUCT_SIZES_SUCCESS:
            return { ...state, loading: false, currentProduct: { ...state.currentProduct, sizes: action.payload } }
        case ProductActionTypes.FETCH_PRODUCT_SIZES_ERROR:
            return { ...state, loading: false, errors: action.payload }
        case ProductActionTypes.FETCH_PRODUCT_ATTRIBUTES_REQUEST:
            return { ...state, loading: true }
        case ProductActionTypes.FETCH_PRODUCT_ATTRIBUTES_SUCCESS:
            return { ...state, currentProduct:  { ...state.currentProduct, ...action.payload, loading: false } }
        case ProductActionTypes.FETCH_PRODUCT_ATTRIBUTES_ERROR:
            return { ...state, currentProduct: { ...state.currentProduct, loading: false,  errors: action.payload }}
        case ProductActionTypes.PRODUCT_CALCULATION_REQUEST:
            return { ...state, loading: true }
        case ProductActionTypes.PRODUCT_CALCULATION_SUCCESS:
            return { ...state,productInputData: {...state.productInputData, requiredFields: {}}, currentProduct:  { ...state.currentProduct, ...action.payload, loading: false } }
        case ProductActionTypes.PRODUCT_CALCULATION_ERROR:
            return { ...state, currentProduct: { ...state.currentProduct, loading: false,  errors: action.payload }}
        default: 
            return state;
    }
}
export default updateState;